// extracted by mini-css-extract-plugin
module.exports = {"container":"roomstay-stats_container__g7I7m","content":"roomstay-stats_content__ycSoS","title":"roomstay-stats_title__yo4zJ","description":"roomstay-stats_description__e8mbP"};